<template>
  <div class="guide-list">
    <div v-if="type == 'search'" class="search-title flex-wrap">
      <div>
        搜索 <span class="main-font-color">{{ searchContent }}</span> 的相关结果
      </div>
      <div>
        符合查询结果：<span class="main-font-color">{{ list.length }}条</span>
      </div>
    </div>
    <div v-else class="guide-title">{{ guideTitle }}</div>
    <div
      v-for="item in list"
      :key="item.id"
      class="guide-item"
      @click="guideDetails(item.id)"
    >
      <p>{{ item.title }}</p>
      <div>{{ item.modify_time.substr(0, 11) }}</div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'GuideList',
  props: {
    list: Array,
    type: String,
    guideTitle: String,
    searchContent: String
  },
  methods: {
    guideDetails(id) {
      this.$emit('guideDetails', id)
    }
  }
}
</script>

<style lang="scss" scoped>
.guide-list {
  padding-left: 80px;
  padding-top: 50px;
  .search-title {
    justify-content: space-between;
    margin-bottom: 25px;
  }
  .guide-title {
    font-size: 30px;
    color: $color_black;
    margin-bottom: 10px;
  }
  .guide-item {
    padding: 25px;
    font-size: 16px;
    border-bottom: 1px solid #d9d9d9;
    position: relative;
    cursor: pointer;
    &:before {
      content: "";
      width: 6px;
      height: 6px;
      position: absolute;
      background-color: $color_blue;
      border-radius: 50%;
      top: 50%;
      left: 0;
      transform: translate(-50%, 0);
    }
    p {
      color: $color_black;
      margin-bottom: 10px;
    }
  }
}
</style>
